// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3pvFm","modalFooterButton":"ModalNotes_modalFooterButton__1g9rK"};